// extracted by mini-css-extract-plugin
export default {"TruckDetailsContainer":"ViewTruck_TruckDetailsContainer__VpKCO","tableWrapper":"ViewTruck_tableWrapper__SOlZ7"};